import { render, staticRenderFns } from "./SuperadminDashboard.vue?vue&type=template&id=0a240c2d&scoped=true"
import script from "./SuperadminDashboard.vue?vue&type=script&lang=js"
export * from "./SuperadminDashboard.vue?vue&type=script&lang=js"
import style0 from "./SuperadminDashboard.vue?vue&type=style&index=0&id=0a240c2d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a240c2d",
  null
  
)

export default component.exports